/* Pembantu untuk baris menu yang dibina sebagai pautan (<a> / <Link>).

   Baris menu WAJIB pautan sebenar dengan alamat betul — bukan butang —
   kalau tidak Chrome langsung tidak menawarkan "Open link in new tab",
   dan klik tengah / Ctrl+klik tidak berfungsi (aduan pengguna 2026-08-16).

   Tetapi klik kiri biasa mesti kekal navigasi SPA (tiada muat semula
   penuh). Jadi setiap pautan menu memintas klik kiri kosong SAHAJA:

       onClick={(e) => { if (klikBiasa(e)) { e.preventDefault(); navigate(p); } }}

   Bila pengguna menekan Ctrl/Cmd/Shift/Alt atau butang tetikus lain, dia
   memang mahu tab atau tetingkap baharu — jangan pintas, biar browser
   buat kerjanya. (React <Link> react-router sudah berkelakuan begini
   dengan sendirinya; pembantu ini untuk pautan yang dibina tangan.)   */
export const klikBiasa = (e) =>
    !e.defaultPrevented && e.button === 0 &&
    !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

export default klikBiasa;
